const SESSION_STORAGE_KEY = 'rideshareContentClosed';

export const isRideshareClosedForSession = () => sessionStorage.getItem(SESSION_STORAGE_KEY) === '1';

export const rememberClosedRideshare = () => {
	sessionStorage.setItem(SESSION_STORAGE_KEY, '1');
};
